import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import logoImg from "assets/img/logo.png"

import Container from "components/Container/Container";
import FormElement from "components/FormElement/FormElement";

import Button from "components/Button/Button";
import { withRouter } from "react-router-dom";

import { submitUserRegisterFormAction, getUserByKeyAction } from "store/actions/Actions";
import { states, statesObj } from "helpers/utils";

import styles from "./UserRegister.module.scss";
import PassowordValidation from "components/PasswordValidation/PasswordValidation";

const Register = props => {
    const { UserLoginFormReducer, getUserByKeyAction, match } = props;
    const [state, setState] = useState({
        active: "t",
        privacy: false,
        security: false,
        status: "active",
        firstname: "",
        lastname: "",
        email: "",
        address_1: "",
        address_2: "",
        country_name: "",
        country_code: "",
        city: "",
        state_code: "",
        state_name: "",
        postcode: "",
        password: "",
        "confirm-password": "",
        phone: "",
        "profile-photo": "",
        "profile-photo-filename": "Add/Upload New",
        showHints: true
    });

    /* eslint-disable-next-line */
    const passwordValidationRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");

    const [stateErrors, setStateErrors] = useState({});

    useEffect(() => {
        getUserByKeyAction({ url_key : match.params.url});
    }, [getUserByKeyAction, match])

    useEffect(() => {
        if (UserLoginFormReducer.data) {
            let state = states.find( c => c.abbrev === UserLoginFormReducer.data.state);
            state = state || {};
            setState((s) => ({
                ...s,
                firstname: UserLoginFormReducer.data.firstname || "",
                lastname: UserLoginFormReducer.data.lastname || "",
                email: UserLoginFormReducer.data.email || "",
                address_1: UserLoginFormReducer.data.address_1 || "",
                address_2: UserLoginFormReducer.data.address_2 || "",
                city: UserLoginFormReducer.data.city || "",
                state_code: state.abbrev || "",
                state_name: state.name || UserLoginFormReducer.data.state || "",
                country_code: UserLoginFormReducer.data.country_code || "",
                country_name: UserLoginFormReducer.data.country_name || "",
                postcode: UserLoginFormReducer.data.postcode || "",
                phone: UserLoginFormReducer.data.phone || "",
                url_key: match.params.url
            }));
        }
    }, [UserLoginFormReducer.data, match]);

    useEffect(() => {
        const state_name = statesObj[state.state] || state.state;
        if (state_name) {
          setState((s) => ({
            ...s,
            state_name,
          }));  
        }
    }, [state.state]);

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]:
                e.target.type === "checkbox"
                    ? e.target.checked : e.target.value === "true" ? true
                    : e.target.value === "false" ? false : e.target.value
        }));
        setStateErrors((s) => ({ ...s, [inputName]: '' }));
    };

    const handleSubmitRegistrationForm = (e) => {
        e.preventDefault();
        if (
            !passwordValidationRegex.test(state.password) ||
            state.password !== state['confirm-password'] ||
            state.firstname === "" ||
            state.lastname === ""
            // state.contact_first === "" ||
            // state.contact_last === "" ||
            // state.phone === "" ||
            // state.address_1 === "" ||
            // state.city === "" ||
            // state.state_name === "" ||
            // state.postcode === ""
        ) {
            setStateErrors({
                ...stateErrors,
                password: state.password === "" ? "The Password is not valid" : "",
                // password: state.password !== state['confirm-password'] ? "Password doesn't match" : "",
                "confirm-password": state.password !== state['confirm-password'] ? "Passwords don't match" : "",
                firstname: state.firstname === "" ? "First name is required" : "",
                lastname: state.lastname === "" ? "Last name is required" : "",
                // contact_first: state.contact_first === "" ? "First name is required" : "",
                // contact_last: state.contact_last === "" ? "Last name is required" : "",
                // phone: state.phone === "" ? "Phone is required" : "",
                // address_1: state.address_1 === "" ? "Address is required" : "",
                // city: state.city === "" ? "City is required" : "",
                // state: state.state_name === "" ? "State is required" : "",
                // postcode: state.postcode === "" ? "Postal code is required" : "",
            });
        } else {
          window.scrollTo({ top:0, behavior:"smooth" });
          props.submitUserRegisterFormAction({
            ...state,
          });
        }
    };

    return (
        <div className={styles.register}>
            <Container>
                <form>
                    <img src={logoImg} alt="The Guard" />
                    <div className={styles.holder}>
                        <div className={styles.container}>

                            <h1>Welcome to The Guard!</h1>
                            <p className={styles.text}>Your new account is ready!<br />Choose a password and complete registration.</p>

                            <FormElement
                                className={styles.form_element}
                                labelText="EMAIL"
                                htmlFor="email"
                                errorMessage={stateErrors.email}
                            >
                                <input
                                    autoComplete="new-password"
                                    name="email"
                                    type="email"
                                    disabled
                                    placeholder="Enter your email address"
                                    value={state.email}
                                    onChange={handleChange("email")}
                                />
                            </FormElement>

                            <FormElement
                                className={styles.form_element}
                                labelText="FIRST NAME"
                                htmlFor="firstname"
                                errorMessage={stateErrors.firstname}
                            >
                                <input
                                    name="firstname"
                                    type="text"
                                    placeholder="Enter your first name"
                                    value={state.firstname}
                                    onChange={handleChange("firstname")}
                                />
                            </FormElement>

                            <FormElement
                                className={styles.form_element}
                                labelText="LAST NAME"
                                htmlFor="lastname"
                                errorMessage={stateErrors.lastname}
                            >
                                <input
                                    name="lastname"
                                    type="text"
                                    placeholder="Enter your last name"
                                    value={state.lastname}
                                    onChange={handleChange("lastname")}
                                />
                            </FormElement>

                            <FormElement
                                className={`${styles.form_element} ${styles.form_element_passowrd}`}
                                labelText="PASSWORD"
                                htmlFor="password"
                                errorMessage={stateErrors.password}
                            >
                                <input
                                    autoComplete="new-password"
                                    name="password"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={state.password}
                                    onChange={handleChange("password")}
                                />
                            </FormElement>

                            {!passwordValidationRegex.test(state.password) ?
                                <PassowordValidation password={state.password} />
                            :
                                ""
                            }

                            <FormElement
                                className={styles.form_element}
                                labelText="CONFIRM PASSWORD"
                                htmlFor="confirm-password"
                                errorMessage={stateErrors["confirm-password"]}
                            >
                                <input
                                    name="confirm-password"
                                    type="password"
                                    placeholder="Confirm your password"
                                    value={state["confirm-password"]}
                                    onChange={handleChange("confirm-password")}
                                />
                            </FormElement>

                            <div className={styles["submit-button-container"]}>
                                <Button
                                    onClick={(e) => handleSubmitRegistrationForm(e)}
                                    text="COMPLETE REGISTRATION"
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </Container>
        </div>
    );
};

const mapStateToProps = (state) => ({
    UserLoginFormReducer: state.UserLoginFormReducer,
});

const mapDispatchToProps = {
    getUserByKeyAction,
    submitUserRegisterFormAction
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register));
